export default __webpack_public_path__ + "images/fc8343f291977feb8b7f1e6ce4fef3ed-rugby.png";